<template>
	<detail :is-edit="false" />
</template>

<script>
	import Detail from './component/Detail'
	
	export default{
		name: 'AddDevice',
		components: {Detail}
	}
</script>